export const RESET = 'EXCMCAR_UPDATE_RESET'
export const SET_ERROR = 'EXCMCAR_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXCMCAR_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXCMCAR_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXCMCAR_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXCMCAR_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXCMCAR_UPDATE_UPDATE_RETRIEVED'
